import styled from 'styled-components';

export const SuggestionCardContainer = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  overflow: hidden;
  margin-top: ${({ theme }) => theme.spacing.level5};
`;

export const SuggestionCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  padding: ${({ theme }) => theme.spacing.level4} ${({ theme }) => theme.spacing.level5};
`;

export const SuggestionCardIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
  flex-shrink: 0;

  .material-symbols-outlined {
    font-size: inherit;
  }
`;

export const SuggestionCardIconSymbol = styled.span`
  font-size: 16px;
`;

export const SuggestionCardTitle = styled.span`
  ${({ theme }) => theme.font.titleSmall};
  color: ${({ theme }) => theme.colors.onSurface};
  flex: 1;
`;

export const SuggestionCardBody = styled.p`
  ${({ theme }) => theme.font.bodyMedium};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  margin: 0;
  padding: 0 ${({ theme }) => theme.spacing.level5} ${({ theme }) => theme.spacing.level4};
`;

export const SuggestionCardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.level3};
  padding: ${({ theme }) => theme.spacing.level3} ${({ theme }) => theme.spacing.level5} ${({ theme }) => theme.spacing.level4};
  border-top: 1px solid ${({ theme }) => theme.colors.outlineVariant}30;
`;

export const SuggestionProceedButton = styled.button`
  ${({ theme }) => theme.font.labelMedium};
  padding: ${({ theme }) => theme.spacing.level3} ${({ theme }) => theme.spacing.level5};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SuggestionDismissButton = styled.button`
  ${({ theme }) => theme.font.labelMedium};
  padding: ${({ theme }) => theme.spacing.level3} ${({ theme }) => theme.spacing.level5};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  border: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  background: transparent;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: ${({ theme }) => theme.colors.surfaceContainerHighest};
  }
`;
